<template>
    <div class="container">
        <div class="icon-header-container">
            <figure class="icon-page-header">
                <img src="/wp-content/uploads/2018/10/page-icon.png" alt="">
            </figure>
            <h1 class="principal-page-title principal-page-title-account">Mis paquetes</h1>
        </div>
        <h2 class="subtitle">Rastrea tus paquetes en tiempo real</h2>
        <div class="form-row packages-form flex-row">
            <div class="form-group">
                <label>Fecha inicial: </label>
                <datepicker  v-model="startDate" format="dd-MM-yyyy" :language="es"></datepicker >
            </div>
            <div class="form-group">
                <label>Fecha final: </label>
                <datepicker  v-model="endDate" format="dd-MM-yyyy" :language="es"></datepicker >
            </div>
            <div class="form-group">
                <label>Numero de tracking:</label>
                <input type="text" v-model="trackingNumber" />
            </div>
            <div class="form-group">
                <label>Estado:</label>
                <select id="status_tracking" name="status_tracking" class="form-control" v-model="trackingState">        
                    <option value="1000">Todos</option>                            
                    <option value="1">MIA</option>
                    <option value="2">SJO</option>
                    <option value="3">Loaded</option>
                    <option value="4">InTransit</option>
                    <option value="5">Crbox</option>
                    <option value="6">En espera de factura</option>
                </select>
            </div>
            <div class="form-group">
                <label class="hidden-label" for="">Buscar paquetes</label>
                <input type="button" value="Buscar Paquetes" class="btn btn-success" id="buscar-paquetes" name="buscar-paquetes" v-on:click="searchPackages">
            </div>
        </div>
        <div class="packages-table-icons flex-row">
            <div>
                <img alt="Miami" src="../assets/InMiami.png">
                <br>
                <span>MIAMI</span>
            </div>
            <div>
                <img alt="Cargado" src="../assets/InLoaded.png">
                <br>
                <span>CARGADO</span>
            </div>
            <div>
                <img alt="En espera de factura" src="../assets/EnEspera.png">
                <br>
                <span>EN ESPERA</span>
            </div>
            <div>
                <img alt="En transito" src="../assets/InProcess.png">
                <br>
                <span>EN TRANSITO</span>
            </div>
            <div>
                <img alt="SJO" src="../assets/InSJO.png">
                <br>
                <span>SJO</span>
            </div>
            <div>
                <img alt="CRBOX" src="../assets/InCrbox.png">
                <br>
                <span>CRBOX</span>
            </div>
        </div>
    <div>
        <vue-good-table
            :columns="columns"
            :rows="packages"
            :pagination-options="{
                enabled: true,
                perPageDropdown: [10, 25, 50,100],
                dropdownAllowAll: false,
                nextLabel: 'siguiente',
                prevLabel: 'anterior',
                rowsPerPageLabel: 'Paquetes por página',
                ofLabel: 'de',
                pageLabel: 'Página'
            }"
            :sort-options="{
                enabled: true,
                initialSortBy: {field: 'receiveddatetime', type: 'desc'}
            }"
            :search-options="{
                enabled: true,
                placeholder: 'Filtrar resultados',
            }"
        styleClass="vgt-table striped" 
        ref="packagesTable">
        <div slot="emptystate">
        No se encontraron paquetes
        </div>
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'statusId'">
                <img :alt="'Status' + props.row.statusId" :src="props.row.statusImages" />
            </span>
            <span v-else-if="props.column.field == 'invoicesCount'">
                <button v-if="props.row.invoicesCount > 0" v-on:click="billsPopUp(props.row.idwarehousereceipt, props.row.invoicesCount)">Ver Factura</button>
                <button v-else v-on:click="billsPopUp(props.row.idwarehousereceipt, props.row.invoicesCount)">Subir Factura</button>
            </span>
            
            <span v-else-if="props.column.field == 'taxReturn' && (props.row.statusName == 'Crbox' || props.row.statusName == 'SJO')">
                <button @click.stop="navigateToTaxRefund(props.row)" class="taxes-return-button ">Devolución Impuestos Amazon</button>
            </span>
            
            <span v-else>
                {{props.formattedRow[props.column.field]}}
            </span>
        </template>
        </vue-good-table>
        <modals-container/>
        <v-dialog/>
        </div>
    </div>  
</template>

<script>
import * as CrboxApi from '../services/CrboxApi.js'
import format from 'date-fns/format'
import subMonths from 'date-fns/sub_months'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import BillsModal from './components/billsModal'
import CrboxLoader from './components/crboxLoader.vue'
import * as CONSTANTS from '@/constants/regex'

export default {
    context: 'package context',
    name: 'Packages',
    data: () => {
        return {
            startDate: "",
            endDate: "",
            es: es,
            trackingNumber: "",
            trackingState: 1000,
            user: {},
            packages: [],
            columns: []
        }
    },
    components: {
        Datepicker,
        VueGoodTable,
        BillsModal,
        CrboxLoader
    },
    mounted(){
        this.columns = this.getColumns()
        this.startDate = subMonths(Date.now(),1)
        this.endDate = Date.now()
        var startDate = format(this.startDate,"DD-MM-YYYY")
        var endDate = format(this.endDate,"DD-MM-YYYY")
        if(this.$auth.user().email){
            let loader = this.$loading.show({
                  container: null,
                  opacity: 1
            },{
            default: this.$createElement('crbox-loader'),
            });
            CrboxApi.getUserInfo(this,this.$auth.user().email)
            .then((response) => {
                this.user = response.data;
                loader.hide()
                this.getPackages(this.user.Consignee.idconsignee,startDate,endDate,null,this.trackingState)
            })
            .catch(()=>{
                this.$auth.logout()
            })
        }
    },
    methods: {
        searchPackages: function(){
            var trackingNumber = null
            var startDate = format(this.startDate,"DD-MM-YYYY")
            var endDate = format(this.endDate,"DD-MM-YYYY")
            if(this.trackingNumber != "") trackingNumber = this.trackingNumber
            this.getPackages(this.user.Consignee.idconsignee,startDate,endDate,trackingNumber,this.trackingState)
        },
        getPackages: function(idconsignee,startDate,endDate,trackingNumber,trackingState){
            let loader = this.$loading.show({
                  container: this.$refs.packagesTable.$el
            });
            CrboxApi.getPackages(this,idconsignee,startDate,endDate,trackingNumber,trackingState)
            .then((response) => {
                this.packages = this.addHtmlToPackages(response.data);
                console.log(this.packages)
                loader.hide()
             })
        },
        getColumns: function(){
            return [
                {
                label: 'Id',
                field: 'idwarehousereceipt',
                hidden: true
                },
                {
                label: 'Estado',
                field: 'statusId'
                },
                {
                label: '#MAWB',
                field: 'masterAirShipmentNumber',
                },
                {
                label: '#HAWB',
                field: 'airShipmentNumber',
                },
                {
                label: 'Recibo',
                field: 'number',
                },
                {
                label: 'Carrier',
                field: 'carrierName',
                },
                {
                label: 'Tracking #',
                field: 'trackingNumber',
                },
                {
                label: 'Recibido',
                field: 'receiveddatetime',
                type: 'date',
                formatFn: this.formatDate
                },
                {
                label: 'Envia',
                field: 'shipperName',
                },
                {
                label: 'Pieza',
                field: 'totalpieces',
                },
                {
                label: 'Peso -Vol-',
                field: 'totalvolumetricweight',
                },
                {
                label: 'Peso -Kg-',
                field: 'totalweight',
                },
                {
                label: 'Notas',
                field: 'consigneeNotes',
                },
                {
                label: 'Facturas',
                field: 'invoicesCount',
                },
                {
                label: 'Devolución Impuestos',
                field: 'taxReturn'
                }
            ]
        },
        formatDate(value){
            return format(value, "DD/MM/YYYY")
        },
        formatStatus(value){ //hay que cambiar las url por las de wordpress
            switch(value){
                case 1:
                    return `/wp-content/themes/unicon-child/js/clientsapp-crboxsite/src/assets/InMiami.png`
                case 2:
                    return `/wp-content/themes/unicon-child/js/clientsapp-crboxsite/src/assets/InSJO.png`
                case 3:
                    return `/wp-content/themes/unicon-child/js/clientsapp-crboxsite/src/assets/InLoaded.png`
                case 4:
                    return `/wp-content/themes/unicon-child/js/clientsapp-crboxsite/src/assets/InProcess.png`
                case 5:
                    return `/wp-content/themes/unicon-child/js/clientsapp-crboxsite/src/assets/InCrbox.png`
                case 6:
                    return `/wp-content/themes/unicon-child/js/clientsapp-crboxsite/src/assets/EnEspera.png`
            }
        },
        
        billsPopUp: function(warehouseId,invoicesCount){
            if(invoicesCount == 0){
                if(!this.userDataIsUpdated()){
                    this.showModalToUpdateInformation()
                }
                else {
                    this.$modal.show(BillsModal, {mode:"new", warehouseId: warehouseId} ,{height: "auto", width: "67.5%", scrollable: true,reset: true,adaptive: true})
                }
            }else{                
                this.$modal.show(BillsModal, {warehouseId: warehouseId} ,{height: "auto", width: "67.5%", scrollable: true,reset: true,adaptive: true})               
            }
            
        },
        addHtmlToPackages: function (packages){
            return packages.map( p => {
                return Object.assign(p,{statusImages: this.formatStatus(p.statusId)})
            })
        },
        userDataIsUpdated: function (){
            const { identificationnumber, identificationtype, omitirReceptor, isCompany } = this.user.Consignee

            if(omitirReceptor == 'S') return true

            //Check for identification
            if(isCompany){
                if(CONSTANTS.ID_ENTERPRISE_REGEX.test(identificationnumber) == false) return false
            }else{
                if(CONSTANTS.ID_NUMBER_REGEX.test(identificationnumber) == false && 
                CONSTANTS.DIMEX.test(identificationnumber) == false &&
                CONSTANTS.NITE.test(identificationnumber) == false) return false
            }
            
            return true
        },
        showModalToUpdateInformation(){
            const { omitirReceptor } = this.user.Consignee
            this.$modal.show('dialog', {
            title: 'Actualización de datos'.toUpperCase(),
            text: 'ESTIMADO CLIENTE POR FAVOR PARA PODER CONTINUAR DEBE ACTUALIZAR LOS DATOS DE ACUERDO A LA SOLICITUD DE HACIENDA PARA EFCTOS DE FACTURA ELECTRÓNICA. EN CASO DE NO SER OBLIGADO TRIBUTARIO DEBERÁ INDICARLO.',
            buttons: [
                {
                title: omitirReceptor == 'S' ? 'Close' : 'No soy obligado tributario'.toUpperCase(),       
                default: false,
                handler: omitirReceptor == 'S' ? null : () => { this.updateUserInfo(); this.$modal.hide('dialog') }
                },
                {
                title: 'Continuar'.toUpperCase(),       
                default: true,
                handler: () => { this.$router.push({ name: 'dashboard', params: {edit: true }}) }
                }
            ]
            })
        },
        updateUserInfo: function (){
            CrboxApi.postEditUser(this, this.user.Consignee, this.user.Consignee.email, null, null, this.user.CompanyCode, this.user.Consignee.phones, this.user.Consignee.addresses, 'S')
            .then(() => {
                let loader = this.$loading.show({
                    container: null,
                    opacity: 1
                },{
                default: this.$createElement('crbox-loader'),
                });
                CrboxApi.getUserInfo(this,this.$auth.user().email)
                .then((response) => {
                    this.user = response.data
                    loader.hide()
                })
            })
        },
        navigateToTaxRefund(packageData) {
            localStorage.setItem('selectedPackage', JSON.stringify(packageData));

            this.$router.push({
                path: '/tax-return',
                query: { 
                    idwarehousereceipt: packageData.idwarehousereceipt,
                }
            });
        }
    }
}
</script>